import React from 'react';
import { Link } from 'react-router-dom';
import { TrainFront, Mail, MapPin, Cat, User } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Footer = () => {
  return (
    <footer id="footer" className="bg-secondary/10 border-t border-border pt-16 pb-8 relative overflow-hidden">

      {/* Animated Train Gimmick */}
      <div className="absolute top-0 left-0 w-full h-12 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 h-full flex items-end pb-1 gap-1 animate-train-scroll text-primary/80">
          {/* 2 Humans */}
          <User className="w-6 h-6 mb-0.5" />
          <User className="w-6 h-6 mb-0.5" />

          {/* 3 Cats */}
          <Cat className="w-6 h-6 mb-0.5" />
          <Cat className="w-6 h-6 mb-0.5" />
          <Cat className="w-6 h-6 mb-0.5" />

          {/* Train Engine */}
          <TrainFront className="w-8 h-8" />

        </div>
        <div className="absolute bottom-0 w-full h-0.5 bg-primary/20"></div>
      </div>

      <div className="container mx-auto px-4 mt-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">

          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-primary">
              <TrainFront className="w-8 h-8" />
              <span className="font-display text-2xl font-bold tracking-widest text-foreground">XEAROX</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Ein Portfolio-Experiment.
              Gebaut mit React, Tailwind und viel Kaffee.
              Offenburg, Deutschland.
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="font-display text-lg font-bold">NAVIGATION</h4>

            <ul className="space-y-2 text-sm text-muted-foreground font-mono">
              <li><a href="/#about" className="hover:text-primary transition-colors">Über Mich</a></li>
              <li><a href="/#projects" className="hover:text-primary transition-colors">Projekte</a></li>
              <li><a href="/#hobbies" className="hover:text-primary transition-colors">Hobbys</a></li>
              <li><Link to="/datenschutz" className="hover:text-primary transition-colors">Datenschutz</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-display text-lg font-bold">KONTAKT</h4>
            <div className="space-y-3">
              <Button variant="outline" className="w-full justify-start gap-3 border-border hover:border-primary hover:text-primary rounded-sm group">
                <Mail className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
                <span>info@xearox.de</span>
              </Button>
              <div className="flex gap-4">
                <a href="https://github.com/xsoftwareforge" target="_blank" rel="noopener noreferrer" className="p-2 bg-background border border-border rounded-sm hover:border-primary hover:text-primary transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-5 h-5"
                  >
                    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-border/50 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-muted-foreground font-mono">
          <p>&copy; {new Date().getFullYear()} XEAROX. All rights reserved.</p>
          <div className="flex items-center gap-2 mt-4 md:mt-0">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span>SYSTEM OPERATIONAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
